import {genereateRoundedTimestamp} from '../common/number.mjs';

export const saveSearchQuery = async (currentQuery, options = {}) => {
	const searchAction = options?.searchAction;
	const searchBoxSource = options?.searchBoxSource;
	const clickedSku = options?.clickedSku;
	const clickedSkuPath = options?.clickedSkuPath;
	const isMobile = options?.isMobile;

	const roundedTimestamp = genereateRoundedTimestamp();
	await fetch('/api/search/save-query', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			searchText: searchAction === 'clicked-product' ? clickedSku : currentQuery,
			searchAction: searchAction,
			searchBoxSource: searchBoxSource,
			clickedSkuPath: clickedSkuPath ?? null,
			deviceType: isMobile ? 'mobile' : 'desktop',
			timeStamp: roundedTimestamp
		})
	});
};
